









import { computed, defineComponent } from '@nuxtjs/composition-api'
import SupportingData, { SupportingDataProp } from './SupportingData.vue'
import { PRODUCT_TYPES } from '~/common/utils/product/constants'
import {
  DatasheetProductAttribute,
  DATASHEET_PRODUCT_ATTRIBUTES,
  getDatasheetProductAttributes,
} from '~/common/utils/datasheet/datasheetProductAttributeMapper'
import { MappedProduct } from '~/types/product/productTypes'
import { doNotShowSupportingData } from '~/common/constants/datasheet'

export default defineComponent({
  components: {
    SupportingData,
  },
  props: {
    product: {
      type: Object as () => MappedProduct,
      required: true,
    },
  },
  setup(props) {
    const supportingData = computed<SupportingDataProp[]>(() => {
      const productType = props.product.productType

      if (doNotShowSupportingData.includes(productType)) {
        return []
      }

      const attributes: DatasheetProductAttribute[] = [DATASHEET_PRODUCT_ATTRIBUTES.APPLICATIONS]

      if (productType !== PRODUCT_TYPES.GROWTH_FACTORS_AND_CYTOKINES) {
        attributes.push(DATASHEET_PRODUCT_ATTRIBUTES.REACTIVITY, DATASHEET_PRODUCT_ATTRIBUTES.SENSITIVITY)
      }

      attributes.push(DATASHEET_PRODUCT_ATTRIBUTES.OBSERVED_MOLECULAR_WEIGHT)

      if (productType !== PRODUCT_TYPES.GROWTH_FACTORS_AND_CYTOKINES) {
        attributes.push(DATASHEET_PRODUCT_ATTRIBUTES.ISOTYPE)
      }

      attributes.push(DATASHEET_PRODUCT_ATTRIBUTES.UNI_PROT_ID, DATASHEET_PRODUCT_ATTRIBUTES.ENTREZ_GENE_ID)

      return getDatasheetProductAttributes(props.product, attributes)
        .filter((x) => !!x.value?.trim()) // remove empty values
        .map((x) => ({ key: x.label, value: x.value! }))
    })

    return {
      supportingData,
    }
  },
})
